module.exports = __webpack_public_path__ + "img/ic_ychz_ok.48ac1507.png";